/**
 * Context Class
 *
 * Encapsulates page context logic for payment flows.
 * Provides semantic methods for checking current page type.
 */
class Context {
    constructor(page) {
        this.page = page;
    }

    /**
     * Get the current page type
     * @returns {string} Page type (checkout, cart, product, etc.)
     */
    getPage() {
        return this.page;
    }

    /**
     * Check if current page is checkout
     * @returns {boolean}
     */
    isCheckout() {
        return this.page === 'checkout';
    }

    isExpressCheckout() {
        return this.page === 'express_checkout';
    }

    /**
     * Check if current page is cart
     * @returns {boolean}
     */
    isCart() {
        return this.page === 'cart';
    }

    /**
     * Check if current page is product page
     * @returns {boolean}
     */
    isProduct() {
        return this.page === 'product';
    }

    isOrderPay() {
        return this.page === 'order_pay';
    }

    isAddPaymentMethod() {
        return this.page === 'add_payment_method';
    }
}

export default Context;